<template>
  <v-alert
    dense
    outlined
    border="left"
    color="#e5183d"
    :icon="false"
    :class="rootClass"
  >
    <div class="partner-premium-banner__inner">
      <v-icon class="partner-premium-banner__lead" size="18">mdi-crown</v-icon>
      <div class="partner-premium-banner__copy">
        <span class="partner-premium-banner__title">Parceiro Premium BRPoints</span>
        <span class="partner-premium-banner__hint">Mais vendas, indicações e ganhos sem limites.</span>
        <v-tooltip bottom max-width="280" content-class="premium-banner-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon x-small class="partner-premium-banner__info" v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          Ative recursos exclusivos para vender mais, indicar parceiros e acessar seus ganhos sem limites.
        </v-tooltip>
      </div>
      <v-btn
        small
        depressed
        color="#e5183d"
        dark
        class="partner-premium-banner__cta"
        @click="activate"
      >
        Ativar
      </v-btn>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PartnerPremiumBanner",

  props: {
    /** Usado no dashboard quando o banner divide a linha com onboarding (altura igual). */
    fillHeight: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rootClass(): Record<string, boolean> {
      return {
        "partner-premium-banner": true,
        "partner-premium-banner--fill": this.fillHeight,
        "fill-height": this.fillHeight,
        "mb-2": this.fillHeight,
        "mb-md-0": this.fillHeight,
      };
    },
  },

  methods: {
    activate() {
      this.$store.commit("SET_PREMIUM_MODAL_VISIBILITY", true);
    },
  },
});
</script>

<style scoped lang="scss">
$brand: #e5183d;

.partner-premium-banner {
  border-radius: 10px !important;
  box-shadow: none !important;
  border-color: rgba(229, 24, 61, 0.35) !important;
  background: rgba(229, 24, 61, 0.05) !important;
}

.partner-premium-banner ::v-deep .v-alert__wrapper {
  padding: 6px 10px 6px 8px !important;
  align-items: center;
}

.partner-premium-banner ::v-deep .v-alert__content {
  padding: 0 !important;
  width: 100%;
  margin: 0 !important;
}

.partner-premium-banner__inner {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.partner-premium-banner__lead {
  flex-shrink: 0;
  color: $brand !important;
  opacity: 0.95;
}

.partner-premium-banner__copy {
  flex: 1 1 140px;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  line-height: 1.3;
}

.partner-premium-banner__title {
  font-weight: 700;
  font-size: 13px;
  color: #23263a;
}

.partner-premium-banner__hint {
  font-size: 12px;
  color: #5c6478;
  font-weight: 500;
}

.partner-premium-banner__info {
  color: #9aa3b8 !important;
  cursor: help;
  flex-shrink: 0;
  margin-left: -4px;
}

.partner-premium-banner__cta {
  flex-shrink: 0;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  letter-spacing: 0.2px;
  min-height: 30px !important;
  padding: 0 12px !important;
}

.partner-premium-banner--fill {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.partner-premium-banner--fill ::v-deep .v-alert__wrapper {
  flex: 1;
  display: flex;
  align-items: center;
}

.partner-premium-banner--fill ::v-deep .v-alert__content {
  display: flex;
  align-items: center;
  width: 100%;
}

@media (max-width: 599px) {
  .partner-premium-banner__inner {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "icon copy"
      "cta cta";
    gap: 6px 10px;
    align-items: start;
  }

  .partner-premium-banner__lead {
    grid-area: icon;
    margin-top: 2px;
  }

  .partner-premium-banner__copy {
    grid-area: copy;
  }

  .partner-premium-banner__cta {
    grid-area: cta;
    width: 100%;
  }
}
</style>
